











import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class EmptyData extends Vue {
  @Prop({default: 250})
  height: number;

  @Prop({default: 500})
  width: number;

  @Prop({default: 'clear'})
  icon: string;

  @Prop({required: true})
  title: string;
}
